import { isEqual } from 'lodash-es';
import { setData } from 'platform/forms-system/src/js/actions';
import { useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { syncSponsorPrefillData } from '../utils/helpers';

/**
 * Applies the sponsor prefill sync to the form data whenever it changes. The
 * latest data is read from the store at effect time, so the sync always builds
 * on top of any dispatch made earlier in the same commit.
 *
 * @returns {void}
 */
export const useSponsorPrefillSync = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const formData = useSelector(state => state.form.data);

  useEffect(() => {
    const latestData = store.getState().form.data;
    const nextData = syncSponsorPrefillData(latestData);
    if (!isEqual(nextData, latestData)) dispatch(setData(nextData));
  }, [dispatch, store, formData]);
};
